/** @jsx jsx */

import { Colors } from '@zapier/design-system';
import { css, jsx } from '@emotion/core';

const Styles = {
  root: (isActive: boolean) => css`
    align-items: center;
    background-color: ${isActive ? Colors.UiPrimaryWeakest : undefined};
    border: 1px solid ${isActive ? Colors.UiPrimaryWeakest : Colors.PrimeBlack};
    border-radius: 5px;
    display: flex;
    height: 34px;
    justify-content: center;
    width: 34px;
  `,
};

type Props = {
  isActive: boolean;
  number: number;
};

function Ordinal({ isActive, number }: Props) {
  return <span css={Styles.root(isActive)}>{number}</span>;
}

export default Ordinal;
